import * as React from 'react';
import Select from 'react-select';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { resetState } from '../../redux/AfrSlice';
import { resetConceptState } from '../../redux/ConceptSlice';
import { EntityReference, getAllEntities, selectEntities } from '../../redux/EntitiesSlice';
import { EditEntityQuery, Entity, getSelectedEntity, loadEntity } from '../../redux/EntitySlice';
import { setIsDirty } from '../../redux/MiscSlice';
import { getPreviousEntityName } from '../../redux/TaxonomyReferenceSlice';
import utilityHelper from '../../utils/utilityHelper';


const PublicEntitySelector = () => {

    const dispatch = useAppDispatch();

    const entities: EntityReference[] = useAppSelector(selectEntities);
    const selectedEntity: Entity | null = useAppSelector(getSelectedEntity);

    const [selectedDropDownItem, setSelectedDropDownItem] = React.useState<{ value: string; label: string } | null>(null);
    const [entityOptions, setEntityOptions] = React.useState<Array<{ value: string; label: string }>>([]);

    var entitySortKeys: any = {};

    const createSortKey = function (a: { value: string; label: string }): string {
        if (entitySortKeys.hasOwnProperty(a.label)) {
            return entitySortKeys[a.label];
        }
        var prefix: string = "f";
        var parts = a.label.split(" - ");
        if (parts.length < 2) {
            prefix = "a";
        } else {
            switch (parts[0]) {
                case "City":
                    prefix = "c";
                    break;

                case "County":
                    prefix = "b";
                    break;

                case "Special District":
                    prefix = "d";
                    break;

                case "Other Entity":
                    prefix = "e";
                    break;

                default:
                    break;
            }
        }
        var result = prefix + parts[1];
        entitySortKeys[a.label] = result;
        return result;
    }

    const sortEntityOptions = function (a: { value: string; label: string }, b: { value: string; label: string }): number {
        var akey: string = createSortKey(a);
        var bkey: string = createSortKey(b);
        var result = akey.localeCompare(bkey);
        return result;
    }
    const addEntityOption = function (entity: EntityReference, ename: string, result: any[]) {
        let entityOptionLabel: string = utilityHelper.getEntityTypeText(entity.code) + " - " + ename;

        var entityOption: { value: string; label: string } = {
            value: entity.code,
            label: entityOptionLabel
        }
        result.push(entityOption);
    }

    const onSelectChangeValue = (e: { value: string; label: string }, action: any) => {
        
        setSelectedDropDownItem(e);
        var eQuery: EditEntityQuery = {
            entityId: e.value + "*",
            taxonomyYear: -1
        };
        dispatch(loadEntity(eQuery));
        dispatch(resetState({}));
        dispatch(resetConceptState({}));
        dispatch(setIsDirty({ IsDirty: false, Page: "" }))
    }

    React.useEffect(() => {
        dispatch(getAllEntities());
    }, [])

    React.useEffect(() => {

        if (entities && entities.length > 0) {

            let result: Array<{ value: string; label: string }> = [];
            let entityReferenceListWithNumericCode: EntityReference[] = entities.filter((element: EntityReference) => Number(element.code[0]) != 9);

            for (var i = 0; i < entityReferenceListWithNumericCode.length; i++) {
                var entity: EntityReference = entityReferenceListWithNumericCode[i];
                addEntityOption(entity, entity.name, result);
                if (entity.references) {
                    entity.references.map(x => (x.type.indexOf("nameChange") > 0) ? addEntityOption(entity, getPreviousEntityName(x), result) : "");
                }
            }
            result.sort(sortEntityOptions);
            setEntityOptions(result);

        } else {
            setEntityOptions([]);
        }

    }, [entities])

    React.useEffect(() => {
        if (selectedEntity != null) {
            var selectedItem = entityOptions.find(x => x.value === selectedEntity.code);
            if (selectedItem) {
                setSelectedDropDownItem(selectedItem);
            } else {
                setSelectedDropDownItem(null);
            }
        } else {
            setSelectedDropDownItem(null);
        }
    }, [selectedEntity]);

    return (
        <React.Fragment>
            <Select
                isSearchable={true}
                isDisabled={false}
                onChange={onSelectChangeValue}
                options={entityOptions}
                value={selectedDropDownItem}
            />
        </React.Fragment>
    )
}

export default PublicEntitySelector;